<template>
	<div class="p-2">
		<div class="d-flex flex-start w-100">
			<div class="mr-2 hidden-md-down">
                <span class="icon-stack icon-stack-lg">
                    <i class="base base-6 icon-stack-3x opacity-100 color-primary-500"></i>
                    <i class="ni ni-notebook icon-stack-1x opacity-100 color-white"></i>
                </span>
			</div>
			<div class="d-flex flex-fill">
				<div class="flex-fill">
					<span class="h5">Налаштування аватара</span>
				</div>
			</div>
		</div>

		<b-overlay :show="is_load">
			<div class="row">
				<div class="col-md-6">
					<div class="card user_avatar_card mt-4" style="position:relative;">
						<div class="cont_ph">
							<div >
								<img class="card-img-top" :src="user_avatar_edit.real"/>
							</div>
						</div>

						<div class="card-footer">
							<div class=" pr-3 d-flex align-items-center flex-wrap">
								<button type="button" v-on:click="edit_avatar" class="w-100 btn btn-lg btn-outline-primary waves-effect waves-themed save_user_settings">
									<span class="fal fa-check mr-1"></span>
									Редагувати
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="d-flex flex-column align-items-center justify-content-center p-4">
						<picture v-if="parseInt(user.id) > 0">
							<source :srcset="user_avatar_template | get_image_from_template(150,150,'webp')"
									type="image/webp"/>
							<source :srcset="user_avatar_template | get_image_from_template(150,150,'png')"
									type="image/png"/>

							<img :src="user_avatar_template | get_image_from_template(150,150,'png')" alt=""
								 class="rounded-circle shadow-2 img-thumbnail" />
						</picture>

						<h5 class="mb-0 fw-700 text-center mt-3">
							{{this.user.name}}
							<small class="text-muted mb-0">
								{{user_company}}
							</small>
							<small class="text-muted mb-0">
								{{this.user.dolznost}}
							</small>
						</h5>
					</div>
				</div>

			</div>
		</b-overlay>


		<avatar_modal></avatar_modal>
	</div>
</template>

<script>

//https://github.com/pqina/filepond/issues/35
import {mapGetters} from "vuex";
import Avatar_modal from "./avatar/avatar_modal";

export default {
	name: "avatar",
	components: {Avatar_modal},
	data: function () {
		return {
			is_load : false,
			user_avatar_edit : {
				real_url : "",
				thumb_url : "",
			},
		}
	},
	props : {
		trigger_load: {
			type: String,
			default: 'saved_user_avatar',
		},
		user_id : {
			type : Number,
			required : true
		}
	},

	created() {
		this.load_user_avatar();
		EventBus.$on('avatar_finish_load',this.reload_user)
	},

	methods: {

		edit_avatar() {
			EventBus.$emit('edit_avatar',this.user_avatar_edit,this.user_id);
		},

		reload_user() {
			this.load_user_avatar();
			this.$store.dispatch('user/LOAD_USER');
		},

		async load_user_avatar() {
			this.is_load = true;
			await api.get('/user/' + this.user_id +'/avatar').then(({data}) => {
				this.is_load = false;
				if(data.status === "operation_success") {
					this.user_avatar_edit = {...this.user_avatar_edit,...data.data};
				}
			}).catch(err => {
				this.is_load = false;
				console.log(err);
			});
		}
	},

	computed : {
		...mapGetters({
			'user': "user/getUser",
		}),

		user_avatar() {
			try {
				if (this.user.id > 0) {
					if (this.user.hasOwnProperty('avatar')) {
						return this.user.avatar;
					}
				}
			} catch (e) {

			}
			return null;
		},

		user_avatar_template() {
			if (this.user_avatar.hasOwnProperty('template')) {
				return this.user_avatar.template;
			}

			return "";
		},

		user_company () {
			if(this.obj_to_null(this.user) != null) {
				return this.user.company + ", " + this.user.department
			}
		},
	}
}
</script>

<style scoped>

</style>
